"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseBlocks = parseBlocks;
function parseBlocks(contents, rawValueBlockNames = []) {
    const blocks = [];
    const lines = contents.split(/\r?\n/);
    let currentBlock;
    for (const line of lines) {
        const trimmedLine = line.trim();
        if (trimmedLine.startsWith('[') && trimmedLine.endsWith(']')) {
            if (currentBlock) {
                blocks.push(currentBlock);
            }
            currentBlock = {
                blockName: trimmedLine.substring(1, trimmedLine.length - 1),
                blockContents: {},
            };
            const match = currentBlock.blockName.match(/^([a-zA-Z]+)[0-9]+$/);
            if (match) {
                currentBlock.blockName = match[1];
                currentBlock.blockContents.id = match[0];
            }
        }
        else if (currentBlock) {
            const equalsIndex = trimmedLine.indexOf('=');
            if (equalsIndex > 0) {
                const key = trimmedLine.substring(0, equalsIndex).trim();
                const value = rawValueBlockNames.includes(currentBlock.blockName) ?
                    line.substring(line.indexOf('=') + 1)
                    : trimmedLine.substring(equalsIndex + 1).trim();
                if (key) {
                    if (Object.hasOwn(currentBlock.blockContents, key)) {
                        currentBlock.duplicateKeys ??= [];
                        currentBlock.duplicateKeys.push(key);
                    }
                    currentBlock.blockContents[key] = value;
                }
            }
        }
    }
    if (currentBlock) {
        blocks.push(currentBlock);
    }
    return blocks;
}
//# sourceMappingURL=altiumBlockParser.js.map